import { Navigate, useLocation } from "react-router-dom";

/* <Navigate> that carries the current query string along — for legacy list
   addresses that became a tab of a hub page (e.g. /power-projects/mpzp?connection=X
   → /power-projects/zamawianie?tab=mpzp&connection=X). `to` may already hold its
   own ?tab=…; the old address's params are appended after it. */
export function RedirectWithSearch({ to }: { to: string }) {
  const { search } = useLocation();
  const extra = search.replace(/^\?/, "");
  const joined = extra ? `${to}${to.includes("?") ? "&" : "?"}${extra}` : to;
  return <Navigate to={joined} replace />;
}
